(function () {
document.addEventListener("DOMContentLoaded", function() {
    var handleIntersection = function(entries) {
        entries.map(function(entry) {
            var step = entry.target.getAttribute("data-step");
            if (entry.isIntersecting) document.querySelector(".".concat(step)).classList.add("active");
            else document.querySelector(".".concat(step)).classList.remove("active");
        });
    };
    var scrollLinks = document.querySelectorAll(".scroll-navigation ul li a");
    scrollLinks.forEach(function(el) {
        el.addEventListener("click", function(e) {
            e.stopPropagation();
            e.preventDefault();
            var step = el.getAttribute("data-anchor");
            document.querySelector("#".concat(step)).scrollIntoView({
                block: "start",
                behavior: "smooth"
            });
        });
    });
    var targets = document.querySelectorAll(".step");
    var observer = new IntersectionObserver(handleIntersection);
    targets.forEach(function(i) {
        if (i) observer.observe(i);
    });
});

})();
//# sourceMappingURL=scroll-navigation.js.map
